import React from 'react';
import './Spinner.css';

export default function Spinner({ text = 'Loading…' }) {
  return (
    <div className="spinner-container">
      <div className="spinner" />
      <span className="spinner-text">{text}</span>
    </div>
  );
}
